'use client'

import React, { Fragment, useContext } from 'react'
import { ReplacerObject } from '../../../../MyStichtingOpenHelpers/src'
import { DictionaryContext } from '../../../providers/dictionary-provider'

export interface DictionaryTextProps {
    textKey: string
    replacer?: ReplacerObject
}

interface Attributes {
    'data-dictionary-key'?: string
}
export const DictionaryText = ({ textKey, replacer }: DictionaryTextProps): JSX.Element => {
    const { getText, areKeysVisible } = useContext(DictionaryContext)

    if (!textKey) return <>no umbraco key provided</>

    const Node = areKeysVisible ? 'span' : Fragment
    const attributes: Attributes = areKeysVisible ? { 'data-dictionary-key': textKey } : {}

    return <Node {...attributes}>{getText(textKey, replacer)}</Node>
}
